import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useAmplitude } from '../../hooks/useAmplitude'
import { AmplitudeEvents } from '../../types/amplitude'
import type { GetStartedClickedProperties } from '../../types/amplitude'

export function Hero() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthContext()
  const { track } = useAmplitude()

  const handleGetStartedClick = () => {
    // Track the event
    const eventProperties: GetStartedClickedProperties = {
      url: window.location.href,
      description: 'simple-landing-page-test',
      location: 'hero',
      isAuthenticated,
      timestamp: new Date().toISOString(),
    }
    track(AmplitudeEvents.GET_STARTED_CLICKED, eventProperties)

    // Navigate
    if (isAuthenticated) {
      navigate('/dashboard')
    } else {
      navigate('/auth')
    }
  }

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Let your users ask <em>anything</em>.
          </h1>
          <p className="hero-subtitle">
            Add AI search to your site to drive growth, revenue, and engagement.
          </p>
          <div className="hero-cta">
            <button className="get-started-btn hero-btn" onClick={handleGetStartedClick}>
              Get Started
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
